@use "../../../../mixins" as *;
@use "../../../../variables" as *;

.product-info {
  margin: 0.813rem 1.25rem 0;

  .description {
    font-weight: 400;
    color: $grey-text;
    font-size: 1.25rem;
    line-height: 1.5rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .detail-view-hint {
    font-size: 0.6875rem;
    margin: 0.625rem 0 1.75rem;
    letter-spacing: 0.034375rem;
    line-height: 1.25rem;
    color: $grey-text;
    text-align: left;
  }

  .separator {
    @include separator-bottom;
  }

  .price-container {
    color: $grey-text;
    font-size: 1rem;
    line-height: 1rem;
    margin-top: 0.375rem;

    .sale-container {
      display: flex;

      div {
        display: flex;
        flex-direction: column;
      }

      .original-price-container {
        padding-left: 0.719rem;
        margin-left: 0.719rem;
        border-left: 0.063rem solid $grey;

        span:first-child {
          margin-bottom: 0.375rem;
          text-decoration: line-through;
        }
      }

      .hide-original-price-container {
        display: none;
      }

      .sale-price-with-original-price {
        color: #e4172e;
      }

      .sale-price {
        color: #e4172e;
        margin: 0;
      }

      .sale-price-container {
        .original-price {
          margin-bottom: 0.375rem;
          text-decoration: line-through;
        }
      }
    }

    .current-exchange-price {
      padding-left: 0.844rem;
      margin-left: 0.844rem;
      border-left: 0.063rem solid $grey;
    }
  }

  .brand-product-number {
    //margin-top: 2.375rem;
    margin-top: 2.125rem;
    margin-bottom: 0.75rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;


    .brand {
      width: 25%;
    }

    .product-number {
      font-weight: 300;
      color: #888888;
      font-size: 0.75rem;
      line-height: 0.75rem;
    }
  }

  .like-share {
    display: flex;
    flex: 1 0 0;
    justify-content: space-evenly;
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;

    @include tablet {
      margin-bottom: 2rem;
    }

    .share {
      min-width: 7.75rem;

      button {
        padding: 0.75rem 1.5rem;
      }

      svg {
        fill: $grey-text;
      }
    }

    .only-share {
      min-width: 10.75rem;
    }

    .like {
      min-width: 10rem;
    }
    
    .likeButton {
      svg {
        fill: $white;
      }
    }
    
    .likeButton, .shareButton {
      display: flex;
      gap: .5rem;
    }
  }

  .additional-container {
    padding: 0.75rem;

    .title {
      display: flex;
      justify-content: space-between;
      font-size: 1.125rem;
      font-weight: 400;
    }

    .list {
      margin: 1.125rem 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .label {
        font-weight: 500;
      }
    }

    .icon {
      align-self: center;
      margin-right: auto;
      margin-left: 0.5rem;
    }

    .epr {
      text-decoration: underline;
      font-weight: 500;

      a {
        color: inherit;
      }
    }

    &.disposal-hint {
      .details {
        margin-top: 0.875rem;
        margin-bottom: 1.125rem;
        line-height: 1.25rem;
        white-space: pre-wrap;
      }

      .icon {
        font-size: 3rem;
      }

      .title {
        max-height: 1.375rem;
      }
    }
  }

  .price-caption {
    color: $grey-text-light;
    font-size: 0.8rem;
    line-height: 1.25rem;
  }
}
